export default __webpack_public_path__ + "static/medl-ffa9d6ffaaa4696904420b0c196774da.jpg";